var map = {
	"./hero.png": 9814,
	"./items/1.jpg": 9268,
	"./items/10.jpg": 5045,
	"./items/11.jpg": 8900,
	"./items/12.jpg": 2517,
	"./items/2.jpg": 7231,
	"./items/3.jpg": 8273,
	"./items/4.jpg": 2171,
	"./items/5.jpg": 4624,
	"./items/6.jpg": 4554,
	"./items/7.jpg": 9084,
	"./items/8.jpg": 66,
	"./items/9.jpg": 5560,
	"./items/astral-stones.png": 2236,
	"./items/atlantis-returns.png": 3785,
	"./items/blackjack.png": 1046,
	"./items/budai-wilds.png": 4559,
	"./items/coming-soon.png": 9759,
	"./items/fortune-888.png": 7709,
	"./items/luckys-rainbow.png": 3427,
	"./items/pirates-revenge.png": 7583,
	"./items/power-of-the-pyramids.png": 2176,
	"./items/roulette.png": 7344,
	"./items/sparkling-7s.png": 2475,
	"./items/spirit-of-the-forest.png": 5994,
	"./items/tiger-kings.png": 5775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2965;